'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { ButtonbarContext } from './buttonbar.context.js';
import { filterProps } from '../core/core.utils.js';
import { conditionalPropType } from '../../prop-types/conditional.prop-type.js';
import { nullishPropType } from '../../prop-types/nullish.prop-types.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, l = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (l = l.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), l.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        r.push.apply(r, l);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
let isMultiSelect = (e)=>'multi-select' === e.variant, u = {
    width: t.oneOf([
        'standard',
        'full-width'
    ]),
    name: t.string,
    variant: t.oneOf([
        'single-select',
        'multi-select',
        'toolbar'
    ]),
    selectedValue: conditionalPropType(isMultiSelect, nullishPropType, t.string),
    defaultSelectedValue: conditionalPropType(isMultiSelect, nullishPropType, t.string),
    onSelectedValueChange: conditionalPropType(isMultiSelect, nullishPropType, t.func),
    selectedValues: conditionalPropType(isMultiSelect, t.arrayOf(t.string.isRequired), nullishPropType),
    defaultSelectedValues: conditionalPropType(isMultiSelect, t.arrayOf(t.string.isRequired), nullishPropType),
    onSelectedValuesChange: conditionalPropType(isMultiSelect, t.func, nullishPropType)
}, p = Object.keys(u);
const Buttonbar = renderWithRef('Buttonbar', u, (t, n)=>{
    let { children: c, variant: i = 'single-select', width: u = 'standard', selectedValue: d, defaultSelectedValue: b = null, onSelectedValueChange: f, selectedValues: O, defaultSelectedValues: g = [], onSelectedValuesChange: y, 'aria-label': m, 'aria-controls': j, name: w } = t, h = new Set([
        'swan-buttonbar'
    ]);
    'standard' !== u && h.add(`swan-buttonbar-${u}`);
    let S = useId(w), [v, _] = useControllableValue({
        value: null != d ? d : void 0,
        onChange: null != f ? f : void 0,
        defaultValue: b,
        defaultOnChange: (e, ...t)=>{
            let [r] = t;
            e(r);
        }
    }), [P, V] = useControllableValue({
        value: null != O ? O : void 0,
        onChange: null != y ? y : void 0,
        defaultValue: g || [],
        defaultOnChange: (e, ...t)=>{
            let [r] = t;
            e(r);
        }
    }), C = 'toolbar';
    switch(i){
        case 'single-select':
            C = 'radiogroup';
            break;
        case 'multi-select':
            C = 'group';
    }
    let M = _object_spread_props(_object_spread({}, filterProps(t, null, null)), {
        role: C,
        'aria-label': m,
        'aria-controls': j
    });
    return jsx(ButtonbarContext.Provider, {
        value: {
            name: S,
            variant: i,
            selectedValue: v,
            onSelectedValueChange: _,
            selectedValues: P,
            onSelectedValuesChange: V
        },
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: n,
            propKeysToRemove: p,
            classNames: h,
            props: _object_spread({}, t, M),
            children: c
        })
    });
});

export { Buttonbar };
